import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.apikeyGoogle = `https://maps.googleapis.com/maps/api/js?v=beta&amp;key=AIzaSyA5ICennvJ9QdFWlbL0p_S8bA25P-mBBMo&amp;&amp;loading=async&amp;&amp;libraries=marker,places&amp;language=es&amp;&amp;`


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <App />
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
